import { PositionIcon } from '@moia-dev/pace-icons'
import { IconButton } from '@moia-dev/pace-web'
import { useContext } from 'react'
import { HereMapContext } from './HereMap'

type ResetPositionButtonProps = {
  onClick?: VoidFunction
}

/**
 * ResetPositionButton is a button that resets the map to its initial position (center + zoom level).
 * It should be used as a direct child of the `MapLegend` component.
 * @param onClick - optional click handler e.g. for analytics
 */
export const ResetPositionButton = ({ onClick }: ResetPositionButtonProps) => {
  const { resetPosition } = useContext(HereMapContext)

  const handleClick = () => {
    resetPosition()
    onClick?.()
  }

  return (
    <IconButton
      onClick={handleClick}
      icon={<PositionIcon />}
      variant="secondary"
      css={theme => ({
        color: theme.semantic.ColorContentReduced,
        boxShadow: '1px 1px 2px 0px rgba(0, 0, 0, 0.25)',
      })}
    />
  )
}
